import { isBrowser } from 'es-toolkit';

import { Runtime } from '../types';

const envName = process.env.NEXT_PUBLIC_MARKETPLACE_ENV;
const runtimeName = process.env.NEXT_RUNTIME;

// development env
export const isDevLogging =
	!envName || envName === 'local' || envName === 'development' || envName === 'staging';

// runtime env
const isEdgeRuntime = runtimeName === 'edge';
const isClientRuntime = isBrowser();
const isServerRuntime = !isEdgeRuntime && !isClientRuntime;

export const runtimeEnvironment: Record<Runtime, boolean> = {
	[Runtime.Edge]: isEdgeRuntime,
	[Runtime.Server]: isServerRuntime,
	[Runtime.Client]: isClientRuntime,
};

export const getCurrentRuntimeEnvironment = () => {
	for (const runtime in runtimeEnvironment) {
		if (runtimeEnvironment[runtime as Runtime]) {
			return runtime as Runtime;
		}
	}
	return Runtime.Client;
};
